"use client";

import { useEffect, useState } from "react";

const useMediaQuery = (device: string) => {
  const [state, setState] = useState({
    windowWidth: typeof window !== "undefined" && window.innerWidth,
    isDesiredWidth: false,
  });

  let minWidth;

  switch (device) {
    case "mobile":
      minWidth = 575;
      break;
    case "tablet":
      minWidth = 996;
      break;
    default:
      minWidth = 1280;
  }

  const resizeHandler = () => {
    const currentWindowWidth = window.innerWidth;
    const isDesiredWidth = currentWindowWidth < minWidth;
    setState({ windowWidth: currentWindowWidth, isDesiredWidth });
  };

  useEffect(() => {
    resizeHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.windowWidth]);

  return state.isDesiredWidth;
};

export default useMediaQuery;
